module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 18,
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 10
    }
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-share-alt"
  }, [_vm._v(" ")]), _c('org-badge'), _vm._v(" " + _vm._s(_vm.title))], 1)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "1.2em"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "report"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Summary")]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "tab-position": "right"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" Requests Report")]), _vm._v(" "), _c('requests-report', {
    attrs: {
      "sharer": _vm.telcoId,
      "stats": _vm.stats
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "stale-report",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-minus"
  }), _vm._v(" Stale Requests")]), _vm._v(" "), _c('stale-request-report')], 1)], 1)], 1), _vm._v(" "), (_vm.isTelco() || _vm.canAccess('project|maintenance|finance|admin|management')) ? _c('el-tab-pane', {
    attrs: {
      "name": "acquire",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-street-view"
  }), _vm._v(" Acquire "), (_vm.stats.rta > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(" " + _vm._s(_vm.stats.rta) + " ")]) : _vm._e()]), _vm._v(" "), _c('request-table', {
    attrs: {
      "type": "RTA",
      "heading": "Acquire",
      "sharer": _vm.telcoId,
      "site-id": _vm.siteId,
      "rejected": _vm.stats.rtaRejected,
      "active": _vm.stats.rta,
      "closed": _vm.stats.rtaClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTelco() || _vm.canAccess('project|maintenance|finance|admin|management')) ? _c('el-tab-pane', {
    attrs: {
      "name": "share",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" New Shares "), (_vm.stats.rts > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(" " + _vm._s(_vm.stats.rts) + " ")]) : _vm._e()]), _vm._v(" "), _c('request-table', {
    attrs: {
      "type": "RTS",
      "heading": "Share",
      "sharer": _vm.telcoId,
      "site-id": _vm.siteId,
      "rejected": _vm.stats.rtsRejected,
      "active": _vm.stats.rts,
      "closed": _vm.stats.rtsClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTelco() || _vm.canAccess('project|maintenance|finance|admin|management')) ? _c('el-tab-pane', {
    attrs: {
      "name": "upgrade",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-tools"
  }), _vm._v(" Upgrades "), (_vm.stats.rtu > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(" " + _vm._s(_vm.stats.rtu) + " ")]) : _vm._e()]), _vm._v(" "), _c('request-table', {
    attrs: {
      "type": "RTU",
      "heading": "Upgrade",
      "sharer": _vm.telcoId,
      "site-id": _vm.siteId,
      "rejected": _vm.stats.rtuRejected,
      "active": _vm.stats.rtu,
      "closed": _vm.stats.rtuClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTelco() || _vm.isBackhaulCo()) || _vm.canAccess('project|maintenance|finance|admin|management')) ? _c('el-tab-pane', {
    attrs: {
      "name": "backhaul",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" Backhaul "), (_vm.stats.rtb > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(" " + _vm._s(_vm.stats.rtb) + " ")]) : _vm._e()]), _vm._v(" "), _c('request-table', {
    attrs: {
      "type": "RTB",
      "heading": "Backhaul",
      "sharer": _vm.telcoId,
      "site-id": _vm.siteId,
      "rejected": _vm.stats.rtbRejected,
      "active": _vm.stats.rtb,
      "closed": _vm.stats.rtbClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTelco() || _vm.canAccess('project|maintenance|finance|admin|management')) ? _c('el-tab-pane', {
    attrs: {
      "name": "dismantle",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-xmark"
  }), _vm._v(" Dismantle "), (_vm.stats.rtd > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(" " + _vm._s(_vm.stats.rtd) + " ")]) : _vm._e()]), _vm._v(" "), _c('request-table', {
    attrs: {
      "type": "RTD",
      "heading": "Dismantle",
      "sharer": _vm.telcoId,
      "site-id": _vm.siteId,
      "rejected": _vm.stats.rtdRejected,
      "active": _vm.stats.rt,
      "closed": _vm.stats.rtdClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isTelco() || _vm.isBackhaulCo()) || _vm.canAccess('project|maintenance|finance|admin|management')) ? _c('el-tab-pane', {
    attrs: {
      "name": "calendar",
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Requests Calendar")]), _vm._v(" "), _c('events-calendar', {
    attrs: {
      "category": "requests",
      "sharer": _vm.telcoId
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0acfbe2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/RequestsView.vue
// module id = 1616
// module chunks = 0